"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDisplayFormParameterDetail = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var sdk_model_1 = require("@gooddata/sdk-model");
var ParameterDetail_1 = require("./ParameterDetail");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var MAX_CACHED_REQUESTS = 50;
var MAX_URL_LENGTH = 100;
var DISPLAY_FORM_ELEMENTS_LIMIT = 3;
var requestCache = new util_1.LRUCache({ maxSize: MAX_CACHED_REQUESTS });
var getDisplayFormLabel = function (type) {
    var messages = react_intl_1.defineMessages({
        hyperlink: { id: "configurationPanel.drillIntoUrl.editor.urlDisplayFormTypeLabel" },
        pushpin: { id: "configurationPanel.drillIntoUrl.editor.geoDisplayFormTypeLabel" },
        default: { id: "configurationPanel.drillIntoUrl.editor.defaultDisplayFormTypeLabel" },
    });
    switch (type) {
        case "GDC.link":
            return messages.hyperlink;
        case "GDC.geo.pin":
        case "GDC.geo.pin_latitude":
        case "GDC.geo.pin_longitude":
            return messages.pushpin;
        default:
            return messages.default;
    }
};
var handleEmptyValues = function (values, intl) {
    return values.map(function (value) { return (value.length === 0 ? sdk_ui_1.emptyHeaderTitleFromIntl(intl) : value); });
};
var prepareValues = function (elements, type) {
    if (type !== "GDC.link") {
        return elements.map(function (_a) {
            var title = _a.title;
            return title;
        });
    }
    return elements.map(function (_a) {
        var title = _a.title;
        return title.length > MAX_URL_LENGTH ? title.substr(0, MAX_URL_LENGTH) + "..." : title;
    });
};
function getElements(backend, projectId, displayFormRef, limit) {
    if (limit === void 0) { limit = 5; }
    return backend
        .workspace(projectId)
        .attributes()
        .elements()
        .forDisplayForm(displayFormRef)
        .withLimit(limit)
        .query();
}
var getCachedRequests = function (backend, projectId, displayFormRef) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var cacheKey, cachedResponse, response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cacheKey = sdk_model_1.objRefToString(displayFormRef);
                cachedResponse = requestCache.get(cacheKey);
                if (cachedResponse) {
                    return [2 /*return*/, cachedResponse];
                }
                return [4 /*yield*/, getElements(backend, projectId, displayFormRef, DISPLAY_FORM_ELEMENTS_LIMIT)];
            case 1:
                response = _a.sent();
                requestCache.set(cacheKey, response);
                return [2 /*return*/, response];
        }
    });
}); };
exports.AttributeDisplayFormParameterDetail = function (props) {
    var title = props.title, label = props.label, type = props.type, displayFormRef = props.displayFormRef, projectId = props.projectId, showValues = props.showValues;
    var intl = react_intl_1.useIntl();
    var backend = sdk_ui_1.useBackendStrict();
    var _a = tslib_1.__read(react_1.useState(true), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = tslib_1.__read(react_1.useState([]), 2), values = _b[0], setValues = _b[1];
    var _c = tslib_1.__read(react_1.useState(0), 2), additionalValues = _c[0], setAdditionalValues = _c[1];
    react_1.useEffect(function () {
        var isMounted = true;
        var getValues = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var response, additional;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCachedRequests(backend, projectId, displayFormRef)];
                    case 1:
                        response = _a.sent();
                        if (isMounted) {
                            additional = response.totalCount - DISPLAY_FORM_ELEMENTS_LIMIT;
                            if (additional > 0) {
                                setAdditionalValues(additional);
                            }
                            setValues(handleEmptyValues(prepareValues(response.items, type), intl));
                            setIsLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (showValues) {
            getValues();
        }
        else {
            setIsLoading(false);
        }
        return function () {
            isMounted = false;
        };
    }, [displayFormRef, type, intl, projectId, showValues]);
    return (react_1.default.createElement(ParameterDetail_1.ParameterDetail, { title: title, label: label, typeName: intl.formatMessage(getDisplayFormLabel(type)), isLoading: isLoading, useEllipsis: type !== "GDC.link", values: values ? values : [], additionalValues: additionalValues }));
};
//# sourceMappingURL=AttributeDisplayFormParameterDetail.js.map